import { axios } from '@/utils/request'

const api = {
  DetailList: '/teacher.php/Material/getDetailList'
}

export function getDetailList (parameter) {
  return axios({
    url: api.DetailList,
    method: 'get',
    params: parameter
  })
}
